// Utility to get the most recent date from a Date, null, or an object with string date values
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function getMostRecentDate(
	input: Date | null | Record<string, string | undefined>,
): string | null {
	if (!input) return null;
	if (input instanceof Date) return input.toISOString();
	if (typeof input === "object") {
		const dates = Object.values(input)
			.filter(Boolean)
			.map((d) => new Date(d as string));
		if (dates.length === 0) return null;
		return dates.reduce((a, b) => (a > b ? a : b)).toISOString();
	}

	return input;
}
